<template>
  <component :is="component ? component : 'div'" v-if="component" :content="content"
             :messagesCount="unreadMessageCount" @logout="logout"
             :client="currentUser.id > 0 ? currentUser : null" :masterPage="masterPage"></component>
</template>

<script setup lang="ts">
import {PropType} from "vue";
import {PageDataHolderFetchedWidget} from "~/lib/interfaces/model/PageDataHolderFetchedWidget";
import {useNuxtApp} from "#app";
import {resolveComponent, useAuth} from "#imports";
import {useWidget} from "../../../../composables/widget/menu";
import {getCurrentUser} from "../../../../composables/auth/useAuthUser";
import {useStateSocket} from "../../../../composables/state/socket";

const props = defineProps({
  widget: Object as PropType<PageDataHolderFetchedWidget>
});
const {$isDesktop} = useNuxtApp();

const {content, masterPage} = useWidget(props.widget);
const {unreadMessageCount} = useStateSocket();
const component = resolveComponent($isDesktop() ? "WidgetMenuMainDesktop" : "WidgetMenuMainPhone");

const currentUser = getCurrentUser();


const logout = async () => {
  // useState("first_preload").value = true;
  await useAuth().logout();
}


</script>

